import React from "react";
import { Container, Row, Col } from "reactstrap";
import "../../styles/about-section.css";

const AboutSection = ({ aboutClass }) => {
  return (
    <section
      className="about__section"
      style={
        aboutClass === "aboutPage"
          ? { marginTop: "0px" }
          : { marginTop: "280px" }
      }
    >
      <Container>
        <Row>
          <Col lg="6" md="6">
            <div className="about__img">
              <img
                src="https://ik.imagekit.io/bo10tvncu/aboutus_winsonstone.webp"
                alt=""
                className="w-100"
              />
            </div>
          </Col>
          <Col lg="6" md="6">
            <div className="about__section-content">
              <h4 className="section__subtitle">About Us</h4>
              {/* <h2 className="section__title">Welcome to car rent service</h2> */}
              <p className="section__description">
                Our organization has been founded on the strong principles of
                quality, integrity and transparency. These inherent values have
                been our guiding lights on our road to excellence and global
                leadership. Our commitment to delivering the best has been
                reinforced by accolades from the industry. We are a direct
                importing and exporting company. We export from our own factory
                situated in India. We are proud as we are offering hundreds of
                various types of high-quality natural stone from quarries
                located around the world. Winson Stone has a wide variety of
                Granite, Marble, Quartz Stone, Sand Stone, Granite Tiles and
                Monuments. What’s more, we have a dedicated team of
                professionals with a rich and varied experience and industry
                expertise.
              </p>

              <h4 className="section__subtitle">Wholesale Solutions</h4>
              {/* <h2 className="section__title">Welcome to car rent service</h2> */}
              <p className="section__description">
                Whatever your demand may be, please let us know we not just meet
                your expectation we will exceed your expectations. We do not
                just sell product we sell solution. We treat every customer as
                our business partner. Our dynamic multisite product system is
                built to for high volume customer needs. We take pride in
                providing custom solution.
              </p>

             
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
